import { useTranslation } from 'react-i18next';
import { useLazyQuery } from '@apollo/client'
import { useParams } from 'react-router-dom'

import CardActionButton from 'components/global/CardActions/CardActionButton'
import { downloadBase64 } from 'utils'

import { OPERATION_EXPORT_RAN_ROOM} from '../operations-gql/queries'
import moment from 'moment/moment'
import { trackEvent } from 'analytics'

const ActionExport = ({room}) => {
  const { t } = useTranslation();
  const {siteId} = useParams()
  const [launchExport, { loading }] = useLazyQuery(OPERATION_EXPORT_RAN_ROOM)
  const { i18n } = useTranslation()
  const handleExport = async () => {
    trackEvent('private_wifi_export', {
      action_scope: 'item',
      format: 'pdf',
    })
    const {
      data: { base64 },
    } = await launchExport({
      variables: { sf_id: siteId, room_ids: [room.id], format: 'pdf', language: i18n.language },
    })
    await downloadBase64({ base64, fileName: `ran_${room.id}_${moment().format('YYYY/MM/DD')}.pdf`})
  }
  return (
    <CardActionButton
      iconlabel={loading ? 'spinner' : 'qrcode'}
      tooltiptitle={t('Exporter')}
      onClick={async() => {
        if (!loading) {
          await handleExport()
        }
      }}
      style={{
        border: '1px solid #E5E7EB',
        borderRadius: '8px',
        padding: '8px'
      }}
    />
  )
}

export default ActionExport
